// Set webpack asset host at runtime. Must be imported at top of entrypoints.
import '../helpers/asset_host';
import App from '../packages/partners_invite/App';
import reactRender from '../helpers/react_render';

const reactRoot = document.getElementById('react-root');

reactRender(App, {
  accountingFirmName: reactRoot.dataset.accountingFirmName,
  accountingFirmLogoUrl: reactRoot.dataset.accountingFirmLogoUrl,
});
